import React, { useContext } from "react";
import { RootStoreContext } from "../core/store/rootStore";
import { Route, Redirect } from "react-router-dom";
import {observer} from "mobx-react";

const PrivateRoute = ({ component:Component , ...rest }) => {
  const rootStore = useContext(RootStoreContext);
  const { isLoggedIn } = rootStore.userStore;

  return <Route {...rest} render={(props) => isLoggedIn ? <Component {...props} /> : <Redirect to={'/login'} /> } />;
};

export default observer(PrivateRoute);
